import React, { useState } from 'react';
import styles from './AdminCountryList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box, Modal } from '@mui/material';
import dayjs from 'dayjs';
import { postList } from '../../../redux/actions/app/postList';
import Player from 'react-player';
import { discountList } from '../../../redux/actions/app/discountList';
import { countryList } from '../../../redux/actions/app/countryList';
import CountryAddEdit from '../../../components/admin/CountryAddEdit/CountryAddEdit';
import { useSelector } from 'react-redux';

const AdminCountryList = () => {
  const columns = [
    {
      label: 'Фото',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100px', height: '100px' }}>
          {val?.logo ? (
            <Box component={'img'} src={val?.logo} sx={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          ) : (
            <Box sx={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}>
              <svg width="100px" height="100px" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="120" height="120" fill="#EFF1F3" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M33.2503 38.4816C33.2603 37.0472 34.4199 35.8864 35.8543 35.875H83.1463C84.5848 35.875 85.7503 37.0431 85.7503 38.4816V80.5184C85.7403 81.9528 84.5807 83.1136 83.1463 83.125H35.8543C34.4158 83.1236 33.2503 81.957 33.2503 80.5184V38.4816ZM80.5006 41.1251H38.5006V77.8751L62.8921 53.4783C63.9172 52.4536 65.5788 52.4536 66.6039 53.4783L80.5006 67.4013V41.1251ZM43.75 51.6249C43.75 54.5244 46.1005 56.8749 49 56.8749C51.8995 56.8749 54.25 54.5244 54.25 51.6249C54.25 48.7254 51.8995 46.3749 49 46.3749C46.1005 46.3749 43.75 48.7254 43.75 51.6249Z"
                  fill="#687787"
                />
              </svg>
            </Box>
          )}
        </Box>
      ),
    },
    {
      label: 'Название',
      onTransform: (val) => val?.name,
    },
    {
      label: 'Код',
      onTransform: (val) => <Box sx={{ textAlign: 'center', whiteSpace: 'normal' }}>+{val?.code || '-'}</Box>,
    },
    {
      label: 'Формат',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: '300px', width: '300px', margin: '0 auto', justifyContent: 'center' }}>
          <Box>{val?.mask?.length ? val?.mask : '-'}</Box>
        </Box>
      ),
    },
  ];
  const [editCountry, setEditCountry] = useState();
  const {
    countryCreate: { data: countryCreateData, loading: countryCreateLoading },
    countryEdit: { data: countryEditData, loading: countryEditLoading },
  } = useSelector((state) => state.app);

  return (
    <Box>
      <div className="">
        <AdminTableList
          onAdd={() => {
            setEditCountry({ type: 'create' });
          }}
          title={'Страны'}
          sliceName={'app'}
          actionName={'countryList'}
          fetch={countryList}
          pathEdit="/admin/promotion/edit"
          columns={columns}
          textEmpty={'Стран нет'}
          noLock
          createData={countryCreateData}
          updateData={countryEditData}
          onEdit={(val) => {
            setEditCountry({ ...val, type: 'edit' });
          }}
        />
      </div>
      <Modal
        open={editCountry}
        onClose={() => {
          setEditCountry();
        }}>
        <Box sx={{ width: '100%', maxWidth: '400px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <CountryAddEdit
            type={editCountry?.type}
            league={editCountry}
            onClose={() => {
              setEditCountry();
            }}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default AdminCountryList;
